export const SET_INTERVIEW_QUESTIONS_LIST = "SET_INTERVIEW_QUESTIONS_LIST";
export const SET_INTERVIEW_QUESTIONS_BY_ID = "SET_INTERVIEW_QUESTIONS_BY_ID";
export const SET_INTERVIEW_QUESTIONS_BY_USERNAME =
  "SET_INTERVIEW_QUESTIONS_BY_USERNAME";
export const SET_REMOVE_INTERVIEW_QUESTIONS = "SET_REMOVE_INTERVIEW_QUESTIONS";
export const SET_ADD_INTERVIEW_QUESTION_LOADING =
  "SET_ADD_INTERVIEW_QUESTION_LOADING";
export const SET_INTERVIEW_QUESTIONS_LIST_LOADING =
  "SET_INTERVIEW_QUESTIONS_LIST_LOADING";
